<template>
  <div>
    <div class="all-content">
      <div class="location">
        <i class="el-icon-location-outline"></i>
        <div class="now-location">当前位置：</div>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="break">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ firstTitle }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-radio-group
        v-model="tabPosition"
        style="margin-bottom: 30px"
      ></el-radio-group>
      <div class="all-content">
        <div class="choose">
          <div :class="['choose-item',tabactive==20?'active':'']"  @click="chooseOne(20, '政协领导')">
            政协领导
          </div>
          <div  :class="['choose-item',tabactive==21?'active':'']" @click="chooseOne(21, '政协常委')">
            政协常委
          </div>
          <div  :class="['choose-item',tabactive==22?'active':'']" @click="chooseOne(22, '政协委员')">
            政协委员
          </div>
          <div :class="['choose-item',tabactive==23?'active':'']" @click="chooseOne(23, '机构设置')">
            机构设置
          </div>
          <div :class="['choose-item',tabactive==24?'active':'']" @click="chooseOne(24, '历届政协')">
            历届政协
          </div>
        </div>
        <div class="content" ref="content" v-if="classifyId!=23">
          <div v-if="classifyId != 23 && classifyId != 21">
            <div
              class="content-right"
              v-for="(item, index) in list"
              :key="index"
            >
              <div
                class="content-right-one"
                v-text="item.title"
                v-if="index === 0"
              ></div>
              <div v-html="item.content"></div>
            </div>
          </div>
          <div v-if="classifyId==21">
            <smalls :classifyId="classifyId"></smalls>
          </div>
        </div>
        <div v-else class="rightbox">
          <first-component :classifyId="classifyId"></first-component>
        </div>
        <div class="content-one" ref="contentOne">
          <div class="content-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import smalls from '../components/small.vue';
import lib from '../api/index';
import FirstComponent from '../components/FirstComponent.vue';
export default {
  components: { smalls, FirstComponent },
  data() {
    return {
      tabPosition: 'left',
      firstTitle: '政协领导',
      list: [],
      classifyId: 20,
    };
  },
computed:{
  tabactive(){
    return this.$route.query.classifyId
  }
},
  mounted() {
    if (this.$route.query.name && this.$route.query.classifyId) {
      this.chooseOne(this.$route.query.classifyId, this.$route.query.name);
    } else {
      this.chooseOne(20, '政协领导');
    }
  },
  methods: {
    displayShow() {},
    chooseOne(classifyId, title) {
      console.log("chooseOne")
      // this.classifyId = parseInt(classifyId);
      if (classifyId != this.$route.query.name) {
        this.$router.push({
          push: '/general',
          query: { name: title, classifyId: classifyId },
        });
      }
      this.firstTitle = title;
      lib
        .appInformationList({
          params: {
            page: 1,
            size: 10,
            classifyId: classifyId,
          },
        })
        .then((res) => {
          console.log("lib")
           this.classifyId = parseInt(classifyId);
          this.list = res.data.records;
        });
    },
  },
};
</script>
<style scoped>
.rightbox>>>.all-content{
  width: 876px;
  margin: unset;
  float: right;
}
.all-content {
  width: 1100px;
  margin: 0 auto;
  overflow: hidden;
  font-size: 15px;
}
.location {
  background-color: rgb(243, 243, 243);
  background-image: url(../assets/img/bg.jpg);
  padding-top: 10px;
  padding-bottom: 10px;
}
.break {
  display: inline-block;
}
.el-icon-location-outline {
  margin-left: 10px;
}
.now-location {
  display: inline-block;
  font-size: 13px;
  position: relative;
  top: -2px;
}
.choose {
  /* margin-left: -40px; */
}
.choose-item {
  /* width: 90px; */
  line-height: 42px;
  padding: 0 46px;
  margin-bottom: 20px;
  background: #F5F5F5;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  box-sizing: border-box;
  width: 200px;
  border-bottom: 1px solid transparent;
}
.choose-item:hover {
  color: #015293;
  background-color: #D4E5F5;
}
.choose-item.active{

  color: #015293;
  background-color: #D4E5F5;
}
.choose {
  width: 220px;
  min-height: 580px;
  float: left;
  font-size: 16px;
  /* display: inline-block; */
}
.choose-one {
  width: 220px;
  min-height: 580px;
  float: left;
  font-size: 16px;
  display: none;
}
.choose ul li {
  list-style: none;
}
.content {
  float: right;
  width: 800px;
  height: 700px;
  padding: 0 20px;
  overflow: scroll;
  margin-bottom: 2px;
  border: 1px solid #ccc;
  margin-bottom: 40px;
  /* display: inline-block; */
}
.content-one {
  float: right;
  width: 800px;
  border: 1px solid #ccc;
  padding: 0 20px;
  display: none;
}
.content-right {
  float: left;
  width: 100%;
  /* background-color: darkcyan; */
  overflow: hidden;
  padding: 20px 0;
  line-height: 2em;
  color: #000000;
  font-size: 18px;
}
.content-right-one {
  /* height: 600px; */
  margin: 0 auto;
  font-weight: bolder;
  text-align: center;
}
.foot {
  width: 1100px;
  margin: 0 auto;
  background-color: #1d71b7;
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/General.vue